import { Component, EventEmitter, Input, Output } from "@angular/core";
import { IClientNumber } from "src/app/models/client/client-number";

@Component({
  selector: "app-client-numbers-form",
  templateUrl: "./client-numbers-form.component.html",
  styleUrls: ["./client-numbers-form.component.scss"],
})
export class ClientNumbersFormComponent {
  @Input() clientNumbers: IClientNumber[] = [];

  @Output() selectNumber = new EventEmitter<string>();
  @Output() buyClick = new EventEmitter<void>();

  get primaryClientNumber() {
    return this.clientNumbers.find(number => number.isPrimary)?.number ?? "*missing*";
  }

  get clientNumberOptions() {
    return this.clientNumbers.map(clientNumber => clientNumber.number);
  }

  get doClientNumbersExist() {
    return this.clientNumbers.length > 0;
  }
}
